import general from '../../utils/general';

export const useController = () => {
    return {general}
}

export default useController;